import { useState, useEffect } from 'react';
import { Row, Col, Table } from 'react-bootstrap';

export default function GestoresFiscais() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const currentMonthYear = new Date().toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
    
    // Function to detect if dates are in American format and convert accordingly
    const convertDatesIfNeeded = (rows) => {
        // Check a sample of dates to determine format
        let americanFormatCount = 0;
        let totalValidDates = 0;
        
        for (const row of rows.slice(0, 10)) { // Check first 10 rows
            const dateStr = row['DATA'];
            if (dateStr && dateStr.trim()) {
                const match = dateStr.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
                if (match) {
                    const [, first, second] = match;
                    totalValidDates++;
                    // If first number > 12, it's likely Brazilian format
                    // If second number > 12, it's likely American format
                    if (parseInt(second) > 12) {
                        americanFormatCount++;
                    }
                }
            }
        }
        
        // If majority suggests American format, convert all dates
        const isAmericanFormat = americanFormatCount > totalValidDates / 2;
        
        if (isAmericanFormat) {
            return rows.map(row => ({
                ...row,
                'DATA': convertAmericanToBrazilian(row['DATA'])
            }));
        }
        
        return rows;
    };
    
    const convertAmericanToBrazilian = (dateString) => {
        if (!dateString || !dateString.trim()) return '';
        
        const match = dateString.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (!match) return dateString;
        
        const [, month, day, year] = match;
        return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    };
    
    useEffect(() => {
        const fetchCSVData = async () => {
            try {
                const response = await fetch('/gestores_e_fiscais.csv');
                const csvText = await response.text();
                
                // Parse CSV with proper handling of quoted fields
                const lines = csvText.split('\n');
                const headers = lines[0].split(',').map(h => h.trim());
                const rows = [];
                
                for (let i = 1; i < lines.length; i++) {
                    if (lines[i].trim()) {
                        // Simple CSV parsing that handles quoted fields
                        const values = [];
                        let currentValue = '';
                        let insideQuotes = false;
                        
                        for (let j = 0; j < lines[i].length; j++) {
                            const char = lines[i][j];
                            if (char === '"') {
                                insideQuotes = !insideQuotes;
                            } else if (char === ',' && !insideQuotes) {
                                values.push(currentValue.trim());
                                currentValue = '';
                            } else {
                                currentValue += char;
                            }
                        }
                        values.push(currentValue.trim()); // Add the last value
                        
                        const row = {};
                        headers.forEach((header, index) => {
                            row[header] = values[index] || '';
                        });
                        rows.push(row);
                    }
                }
                
                // Convert dates if needed based on format detection
                const processedRows = convertDatesIfNeeded(rows);
                setData(processedRows);
            } catch (error) {
                console.error('Error loading CSV data:', error);
            } finally {
                setLoading(false);
            }
        };
        
        fetchCSVData();
    }, []);
    
    if (loading) {
        return (
            <Row>
                <Col xs="12">
                    <p>Carregando dados...</p>
                </Col>
            </Row>
        );
    }
    
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em <a href="/prestacao-de-contas">Prestação de Contas</a> / Gestores e Fiscais de Contratos</small></p>
                <p><small>Dados atualizados em {currentMonthYear}</small></p>
            </Col>
            <Col xs={{ span: 2, offset: 10 }} className="mb-2 text-center">
                <div>
                    <a href="/gestores_e_fiscais.csv" title="Download em CSV">
                        <img src="/img/download-csv.png" height="16" width="16" alt="" />
                        CSV
                    </a>
                </div>
            </Col>
            <Col xs="12">
                <div className="table-responsive">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>CREDOR</th>
                                <th>CNPJ</th>
                                <th>CONTRATO</th>
                                <th>VIGÊNCIA</th>
                                <th>LICITAÇÃO</th>
                                <th>PREGÃO</th>
                                <th>ADESÃO</th>
                                <th>DISPENSA</th>
                                <th>PROCESSO ADM</th>
                                <th>FISCAL 1</th>
                                <th>FISCAL 2</th>
                                <th>PORTARIA</th>
                                <th>DATA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    <td>{row['CREDOR'] || ''}</td>
                                    <td>{row['CNPJ'] || ''}</td>
                                    <td>{row['Nº DO CONTRATO'] || ''}</td>
                                    <td>{row['VIGÊNCIA'] || ''}</td>
                                    <td>{row['LICITAÇÃO'] || ''}</td>
                                    <td>{row['PREGÃO'] || ''}</td>
                                    <td>{row['TERMO DE ADESÃO'] || ''}</td>
                                    <td>{row['DISP. DE LICITAÇÃO'] || ''}</td>
                                    <td>{row['PROCESSO ADM'] || ''}</td>
                                    <td>{row['NOME DO FISCAL'] || ''}</td>
                                    <td>{row['NOME DO GESTOR'] || ''}</td>
                                    <td>{row['Nº'] || ''}</td>
                                    <td>{row['DATA'] || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Col>
        </Row>
    );
}